import { PageCodeComparisonType } from 'constants/claims';
import { HeaderViewType } from 'constants/loanApplication';
import { PAGE_CODES } from 'constants/pageCodes';

export const HEADER_VIEW_PAGE_CODE_BY_TYPE = {
  [HeaderViewType.LOAN]: PAGE_CODES.HEADER_VIEW_LOAN,
  [HeaderViewType.CONTACT]: PAGE_CODES.HEADER_VIEW_CONTACT,
  [HeaderViewType.LEAD]: PAGE_CODES.HEADER_VIEW_LEAD,
  [HeaderViewType.SUB_COMPANY]: PAGE_CODES.HEADER_VIEW_SUB_COMPANY,
};

export const ANY_HEADER_VIEW_PAGE_CODE = {
  pageCodes: Object.values(HEADER_VIEW_PAGE_CODE_BY_TYPE),
  comparisonType: PageCodeComparisonType.OR,
};
